import { computed, inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { createFetchState } from '@at/shared';
import { PeopleApi } from '../api';
import { ActivatedRoute } from '@angular/router';
import { UserService } from '@at/user';

@Injectable()
export class PeopleService {
  readonly #peopleApi = inject(PeopleApi);
  readonly #activatedRoute = inject(ActivatedRoute);
  readonly #userService = inject(UserService);

  public state = toSignal(
    createFetchState({
      fetchCall: () => this.#peopleApi.getMembers(this.#activatedRoute.snapshot.params['id']),
    }),
  );

  readonly #user = toSignal(this.#userService.user$);

  public participants = computed(() => {
    return this.state()?.data?.members;
  });

  public invites = computed(() => {
    return this.state()?.data?.invites;
  });

  public isMember = computed(() => {
    const usr = this.#user();
    const members = this.state()?.data?.members ?? [];

    return members.some((member) => member.userId === usr?.userId);
  });

  public updateState() {
    const state = this.state();
    if (!state) return;

    state.update();
  }
}
